import { format } from 'date-fns'
import { pl } from 'date-fns/locale'

import type { WorkSession } from './use-work-sessions'

interface SessionsListProps {
  sessions: WorkSession[]
}

function formatDuration(seconds: number | null): string {
  if (seconds === null) return '—'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  if (h === 0) return `${m}m`
  return `${h}h ${m}m`
}

export default function SessionsList({ sessions }: SessionsListProps) {
  if (sessions.length === 0) {
    return (
      <p className="text-center text-sm text-text-faint py-8">
        Brak sesji w wybranym okresie
      </p>
    )
  }

  return (
    <ul>
      {sessions.map((s) => {
        const start = new Date(s.startedAt)
        const end = s.endedAt ? new Date(s.endedAt) : null
        return (
          <li
            key={s.id}
            className="border-b border-border-subtle py-3 flex items-baseline justify-between gap-3 last:border-b-0"
          >
            <div className="flex flex-col gap-0.5">
              <span className="text-sm font-medium text-text-primary">
                {format(start, 'EEE d MMM', { locale: pl })}
              </span>
              <span className="text-xs text-text-muted font-mono tabular-nums">
                {format(start, 'HH:mm')} – {end ? format(end, 'HH:mm') : '(trwa)'}
              </span>
            </div>
            <div className="flex items-center gap-2">
              {s.autoClosed && (
                <span className="inline-flex items-center rounded-pill bg-warning/10 text-warning px-2 py-0.5 text-[10px] uppercase tracking-wider">
                  autozamknięta
                </span>
              )}
              <span className="text-sm font-mono tabular-nums text-text-primary">
                {formatDuration(s.durationSeconds)}
              </span>
            </div>
          </li>
        )
      })}
    </ul>
  )
}
